import { render } from "./SelfAssessmentV2EncouragementFeedback.vue?vue&type=template&id=8d973d2c&scoped=true"
import script from "./SelfAssessmentV2EncouragementFeedback.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2EncouragementFeedback.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2EncouragementFeedback.vue?vue&type=style&index=0&id=8d973d2c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d973d2c"]])

export default __exports__